import React, { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  Row,
  Col,
  Image,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import "./AdminForgotPassScreen.css";

import { forgotPassword } from "../actions/userActions";
import { LinkContainer } from "react-router-bootstrap";
import Swal from "sweetalert2";

function AdminForgotPasswordScreen({ location, history }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState([])
  const dispatch = useDispatch();

  const redirect = location.search
    ? location.search.split("=")[1]
    : "/dashboard";

  // console.log("email", email);

  // useEffect(() => {
  //   console.log(userForgotPassword);
  //   if (userForgotPassword.userInfo) {
  //     if (userForgotPassword.userInfo.status) {
  //       setLoading(false);

  //     } else {
  //       setLoading(false);
  //       Swal.fire("Failed", "User was not found", "error");
  //     }
  //   }
  // }, [userForgotPassword]);

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(forgotPassword(email, Swal, history, process.env.REACT_APP_FRONT_NO_SLASH));

    setLoading(false);

  };

  const emailChange = e => {
    setEmail(e.target.value)
    if (e.currentTarget.value.includes(" ")) {
      e.currentTarget.value = e.currentTarget.value.replace(/\s/g, "");
    }
  };

  const handleKeyDown = e => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  return (
    <>
      <Navbar
        bg="info"
        variant=""
        expand="lg"
        collapseOnSelect
        className="p-2 mb-5"
      >
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto bg-info">
            <LinkContainer to="/admin">
              <a>
                <Image src="/icon.png" width="270" height="78" />
              </a>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Row className="mt-5 d-flex justify-content-center">
        <Col md={6}>
          <h1 className="text-center mb-4 text-info">Forgot Your Password?</h1>
          <Row className="mb-4">
            <Col md={2}></Col>
            <Col md={8}>
              <h5 className="text-center text-muted">
                Please enter your registered email address. An email
                notification with a password reset link will be sent to you.
              </h5>
            </Col>
            <Col md={2}></Col>
          </Row>

          <Form onSubmit={submitHandler}>
            <Row>
              <Col md={2}></Col>
              <Col md={8}>
                <Form.Group controlId="email" className="mb-2">
                  <Form.Label className="">Enter Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    // placeholder='Enter Email'
                    value={email}
                    onKeyDown={handleKeyDown}
                    onChange={emailChange}
                  ></Form.Control>
                </Form.Group>
                {/* <Row>
                  <Col md={4} style={{ marginLeft: "auto" }}>
                    <div className="d-grid gap-2 mt-3 mb-4">
                      <Button
                        type="submit"
                        className="text-center"
                        variant="success"
                      >
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "SUBMIT"
                        )}
                      </Button>
                    </div>
                  </Col>
                  <Col md={4} style={{ marginRight: "auto" }}>
                    <div className="d-grid gap-2 mt-3 mb-4">
                      <Button
                        type="submit"
                        className="text-center"
                        variant="success"
                      >
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "SUBMIT"
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row> */}
                <Row className="d-flex justify-content-center">
                  <Col md={6} className="px-1">
                    <div className="d-grid gap-2 mt-3">
                      <Button
                        type="submit"
                        className="text-center"
                        variant="success"
                      >
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "SUBMIT"
                        )}
                      </Button>
                    </div>
                  </Col>
                  <Col md={6} className="px-1">
                    <div className="d-grid gap-2 mt-3 mb-4 cancel">
                      <Button
                        onClick={() => history.push("/admin")}
                        type="button"
                        variant="danger"
                      >
                        CANCEL
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
        <Row className=" footer-text px-2 ">
          <br />
          <small className="text-secondary text-center position-absolute footer-text">
            Energy Sense Rebate Program for Central, Ducted Systems <br />
            Copyright &copy; 2022 GPA Powered By Xtendly
          </small>
        </Row>
      </Row>
    </>
  );
}

export default AdminForgotPasswordScreen;
